package com.ustadmobile.core.paging

import com.ustadmobile.door.util.systemTimeInMillis

class RefreshCommand(val time: Long = systemTimeInMillis())
